import type { TFetchStatus } from "store/types";

const useDetailPreviewLoading = (
    routeId: number | null,
    currentId: number | undefined,
    detailStatus: TFetchStatus,
    isListLoading = false,
) => {
    const hasMatchingItem = routeId != null && currentId === routeId;

    return {
        hasMatchingItem,
        // Skeleton only while this route has no fiche yet. A matching fiche stays up across list reloads.
        isHeaderLoading: !hasMatchingItem && (isListLoading || routeId != null),
        // A succeeded fiche for someone else is not this route's content.
        isContentLoading:
            (!hasMatchingItem && isListLoading) ||
            (routeId != null && (!hasMatchingItem || detailStatus !== "succeeded")),
    };
};

export default useDetailPreviewLoading;
